/**
 * Return the average of an array of values
 * @param arr
 */
export function average(arr: number[]): number {
  const sum = arr.reduce((acc, curr) => acc + curr, 0)
  return sum / arr.length
}
